(async () => {
  const root = document.querySelector('[data-ab-home-finder]');
  if (!root) return;

  const form = root.querySelector('[data-ab-home-form]');
  const make = root.querySelector('[name="make"]');
  const model = root.querySelector('[name="model"]');
  const year = root.querySelector('[name="year"]');
  const submit = root.querySelector('button[type="submit"]');
  const status = root.querySelector('[data-ab-home-status]');
  const toggle = root.querySelector('[data-ab-home-toggle]');
  const formWrap = root.querySelector('#fitment-form-wrap');

  const clean = (value) => String(value ?? '').trim();
  const canonicalMake = (value) => window.ABFitment
    ? ABFitment.displayMake(value)
    : clean(value);

  const reset = (select, label) => {
    if (!select) return;
    select.replaceChildren(new Option(label, ''));
    select.disabled = true;
  };

  const populate = (hierarchy) => {
    if (!hierarchy || !make || !model || !year) return;
    Object.keys(hierarchy).sort().forEach((value) => make.add(new Option(canonicalMake(value), value)));

    make.addEventListener('change', () => {
      reset(model, 'Model');
      reset(year, 'Year');
      submit.disabled = true;
      const models = hierarchy[make.value] || {};
      Object.keys(models).sort().forEach((value) => model.add(new Option(value.toUpperCase(), value)));
      model.disabled = !make.value;
    });

    model.addEventListener('change', () => {
      reset(year, 'Year');
      submit.disabled = true;
      const years = hierarchy[make.value]?.[model.value] || [];
      years.map(String).sort((a, b) => Number(a) - Number(b)).forEach((value) => year.add(new Option(value, value)));
      year.disabled = !model.value;
    });

    year.addEventListener('change', () => {
      submit.disabled = !year.value;
    });
  };

  if (toggle && formWrap) {
    toggle.addEventListener('click', () => {
      const open = formWrap.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', String(open));
    });
  }

  if (form) {
    form.addEventListener('submit', () => {
      if (status) status.textContent = 'Loading compatible products…';
    });
  }

  let fitmentData = [];
  try {
    const response = await fetch(root.dataset.abHomeCatalogUrl, { credentials: 'same-origin' });
    if (!response.ok) throw new Error('catalog');
    const catalog = await response.json();
    fitmentData = (catalog.products || []).map((product) => product.fitment).filter(Boolean);
  } catch (error) {
    if (status) status.textContent = 'Vehicle data is unavailable. Please refresh the page.';
    return;
  }
  if (!window.ABFitment) {
    if (status) status.textContent = 'Vehicle data is unavailable. Please refresh the page.';
    return;
  }

  const tree = ABFitment.build(fitmentData);
  if (!Object.keys(tree.hierarchy).length) {
    if (status) status.textContent = 'No vehicle applications are published yet.';
    return;
  }

  populate(tree.hierarchy);
})();